import React, { useState } from 'react'
import { Link } from 'gatsby'
import { useLocation } from '@reach/router'
import './NavigationMenu.scss'

const routes = [
  { slug: '/', text: 'Home' },
  { slug: '/how-it-works', text: 'How it works' },
  { slug: '/model', text: 'The Model' },
  { slug: '/about', text: 'About' },
  { slug: '/pricing', text: 'Pricing' },
]

export const NavigationMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const { pathname } = useLocation()
  const openStyle = { height: '100dvh', paddingTop: 40, paddingBottom: 40 }

  const handleMenuClick = () => setMenuOpen(false)

  return <div className="navigation-menu">
    <div onClick={() => setMenuOpen(true)} className="trigger">
      <Menu />
    </div>
    <div
      className="menu"
      style={menuOpen ? openStyle : undefined}
    >
      <div onClick={() => setMenuOpen(false)} style={{ rotate: '45deg', fontSize: 36 }}>
        +
      </div>
      {routes.map(route => {
        const { slug, text, subOptions } = route
        return (
          <div
            key={slug}
            className={pathname === slug ? 'active' : ''}
            onClick={() => handleMenuClick(route)}
          >
            <h5>
              {subOptions ? text : <div onClick={() => setTimeout(() => document.getElementById('scrollTarget').scrollIntoView({ behavior: 'smooth' }), 100)}>
                <Link to={slug}>{text}</Link>
              </div>}
            </h5>
          </div>
        )
      })}
    </div>
  </div>
}
const Menu = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 18H3.5V16H15.5V18ZM21.5 13H3.5V11H21.5V13ZM15.5 8H3.5V6H15.5V8Z" fill="white" />
  </svg>
)